import LandingPage from './landing/LandingPage';

export default LandingPage;
